export default __webpack_public_path__ + "static/road-to-thailand-img-1-95d255a5a104510bb81cf5bf09fbd41a.png";